import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'resourcesFilter',
  pure: false
})
export class ResourcesFilterPipe implements PipeTransform {
  transform(items: any[], text: string): any[] {
    if (!items || !text) {
      return items;
    }

    // filter items array, items which match and return true will be kept, false will be filtered out
    return items.filter((item: any) => this.applyFilter(item, text));
  }

  applyFilter(resource: any, text: string): boolean {
    if( text ){
      if (resource.name.toLowerCase().indexOf(text.toLowerCase()) === -1) {
        return false;
      }
    }

    return true;
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/cot-web/src/app/components/resources/list/resources-filter.pipe.ts